import React from 'react'
import './HomePage.css'
import Navbar from '../Navbar/Navbar'
import KongreAfis from '../../assets/afisson2.jpg'
import Footer from '../Footer/Footer'

function HomePage() {
  return (
  <div>
      <div className="homepage-container">
        <Navbar/>
        
        {/* Üst Bölüm: Afiş ve Kısa Özet */}
        <div className="hero-section">
            <div className="hero-container">
                <div className="hero-image">
                    <img src={KongreAfis} alt="34. Ulusal Yönetim ve Organizasyon Kongresi" />
                </div>
                <div className="hero-info">
                    <span className="event-date">20 - 23 Mayıs 2026</span>
                    <h2>34. ULUSAL YÖNETİM VE <br/> ORGANİZASYON KONGRESİ</h2>
                    <p className="location">Sivas Cumhuriyet Üniversitesi</p>
                    <div className="quick-dates">
                        <div className="date-item"><strong>Bildiri Son Tarih:</strong> 15 Nisan 2026</div>
                        <div className="date-item"><strong>Kayıt Son Tarih:</strong> 10 Mayıs 2026</div>
                    </div>
                    
                    {/* Buton Grubu */}
                    <div className="hero-buttons" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                        <button className="primary-btn">Bildiri Gönder</button>
                        
                        {/* PDF Program Butonu */}
                        <a 
                            href="/kongreoturum2.pdf" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="secondary-btn"
                            style={{ 
                                display: 'inline-flex', 
                                alignItems: 'center', 
                                backgroundColor: '#c0392b', 
                                color: '#fff', 
                                padding: '10px 20px', 
                                borderRadius: '5px', 
                                textDecoration: 'none',
                                fontWeight: 'bold',
                                fontSize: '14px'
                            }}
                        >
                            <i className="fas fa-file-pdf" style={{ marginRight: '8px' }}></i>
                            Kongre Oturum Programı (PDF)
                        </a>
                    </div>
                </div>
            </div>
        </div>

        {/* Yeni Eklenen Bilgi Bölümleri */}
        <section className="details-section">
            <div className="details-container">
                
                {/* 1. Bölüm: Dönem Başkanı Mesajı */}
                <div className="president-message">
  <h3>Dönem Başkanı Mesajı</h3>
  <div className="underline"></div>

  <p>
    Yönetim ve Organizasyon Bilim Dalının kıymetli akademisyenleri;<br/><br/>

    İlk olarak 1993 yılında İstanbul Üniversitesi ve Boğaziçi Üniversitesi ortaklığıyla düzenlenen
    Ulusal Yönetim ve Organizasyon Kongresi günümüze kadar düzenli bir şekilde yapılmaktadır.
    Ülkemizin en köklü ve saygın kongrelerinden biri olan Ulusal Yönetim ve Organizasyon
    Kongresi’nin 34.’sü bu yıl 20-23 Mayıs tarihleri arasında Sivas’ta gerçekleştirilecektir.<br/><br/>

    Kongremiz insan kaynakları yönetimi, örgüt teorisi, örgütsel davranış, stratejik yönetim ve
    işletme tarihi gibi alanlarda çalışma yapan bilim insanlarını bir araya getirerek ülkemizde
    33 yıldır bu alanda etkileşim ve bilgi paylaşımına önemli katkılar sunmaktadır.<br/><br/>

    Kongre Düzenleme Komitesi olarak 2026 yılında tarihi, doğası, kültürel zenginlikleri,
    gastronomisi ve sahip olduğu tüm değerleriyle önemli bir Anadolu kenti olan Sivas’ta sizleri
    misafir etmekten büyük mutluluk duyacağız.<br/><br/>

    Kongremiz yüz yüze yapılacak ve sunumlar Türkçe olacaktır. Uzaktan (çevrimiçi) katılım
    seçeneği bulunmamaktadır.<br/><br/>

    20-23 Mayıs 2026 tarihlerinde Sivas’ta Yönetim ve Organizasyon ailesinin siz değerli üyeleri
    ile sağlıkla buluşabilmek dileğiyle, selam ve saygılarımı sunarım.
  </p>

  <div className="signature">
    <strong>Prof. Dr. Berrin FİLİZÖZ</strong>
    <span>34. Ulusal Yönetim ve Organizasyon Kongresi Dönem Başkanı</span>
  </div>
</div>

                {/* 2. Bölüm: Kongre Hakkında Önemli Notlar */}
                <div className="about-grid">
                    <div className="about-card">
                        <h4>Köklü Geçmiş</h4>
                        <p>İlk olarak 1993 yılında düzenlenen kongremiz, 33 yıldır bilgi paylaşımına önemli katkılar sunmaktadır.</p>
                    </div>
                    <div className="about-card">
                        <h4>Geniş Kapsam</h4>
                        <p>İnsan kaynakları, örgüt teorisi, örgütsel davranış ve stratejik yönetim gibi temel alanları bir araya getiriyoruz.</p>
                    </div>
                    <div className="about-card">
                        <h4>Yüz Yüze Katılım</h4>
                        <p>Kongremiz sadece yüz yüze yapılacak olup, sunum dili Türkçe'dir. Çevrimiçi katılım seçeneği bulunmamaktadır.</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <Footer/>
  </div>
  )
}

export default HomePage